package com.milta.core.localization.translations.sq

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Skano një dokument",
    reviewTitle = "Verifiko të dhënat",
    fileSentSuffix = "dërguar tani",
    analysingTitle = "Po lexohet dokumenti…",
    analysingSubtitle = "Po zbulojmë dërgesat në foto. Kërkohen vetëm pak sekonda.",
    deliveriesDetectedSuffix = "dërgesa të zbuluara",
    toCompleteSuffix = "për t'u plotësuar",
    reviewHint = "Plotësoni dërgesat e shënuara para se t'i shtoni në rrugë",
    addressMissingWarning = "Adresë mungon",
    nameMissingWarning = "Emër mungon",
    recipientMissingPlaceholder = "Marrësi nuk u zbulua",
    phoneNotDetectedNote = "Telefoni nuk u zbulua — shtimi nuk bllokohet",
    deadlineLabelPrefix = "Ora limite",
    completeLinkLabel = "Plotëso",
    addToRouteButtonPrefix = "Shto në rrugë",
    correctionRecipientLabel = "Marrësi",
    correctionAddressLabel = "Adresa",
    correctionPhoneLabel = "Telefoni",
    correctionDeadlineLabel = "Ora limite",
    attemptLabel = "Përpjekje",
    unreadableTitle = "Foto e palexueshme.",
    unreadableMessage = "Nuk zbuluam asnjë dërgesë në këtë imazh — bëni një foto të kornizuar dhe të ndriçuar mirë.",
    retakePhotoButton = "Bëj një foto të re",
    manualEntryButton = "Vendos manualisht",
    maxAttemptsTitle = "Ende e palexueshme pas 2 përpjekjeve.",
    maxAttemptsMessage = "Plotësoni këtë dërgesë manualisht, ose rifilloni skanimin me një dokument të ri.",
    retakeUnavailableLabel = "Bëj një foto të re — jo e disponueshme",
    rateLimitTitle = "Shumë skanime të kryera kohët e fundit.",
    rateLimitMessage = "Provoni përsëri pak më vonë, ose plotësoni këtë dërgesë manualisht ndërkohë.",
    rateLimitRetakeUnavailableLabel = "Bëj një foto të re — jo e disponueshme për momentin",
)
